import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import logo from '../assets/logo.png';

const CITIES = [
  { id: 'cape-coral', name: 'Cape Coral', slug: 'cape-coral' },
  { id: 'fort-myers', name: 'Fort Myers', slug: 'fort-myers' },
  { id: 'fort-myers-beach', name: 'Fort Myers Beach', slug: 'fort-myers-beach' },
  { id: 'sanibel', name: 'Sanibel', slug: 'sanibel' },
  { id: 'captiva', name: 'Captiva', slug: 'captiva' },
  { id: 'bonita-springs', name: 'Bonita Springs', slug: 'bonita-springs' },
  { id: 'estero', name: 'Estero', slug: 'estero' },
  { id: 'naples', name: 'Naples', slug: 'naples' },
  { id: 'marco-island', name: 'Marco Island', slug: 'marco-island' },
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container-main section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <img src={logo} alt="Southwest FL Vacation Rentals" className="h-16 w-auto" />
            </Link>
            <p className="text-slate-400 text-sm">
              Your trusted partner for vacation rentals in Southwest Florida. 
              Discover curated stays with clear pricing and local support.
            </p>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Destinations</h4>
            <ul className="space-y-2">
              {CITIES.slice(0, 5).map((city) => (
                <li key={city.id}>
                  <Link 
                    to={`/${city.slug}-vacation-rentals`}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Destinations */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">More Locations</h4>
            <ul className="space-y-2">
              {CITIES.slice(5).map((city) => (
                <li key={city.id}>
                  <Link 
                    to={`/${city.slug}-vacation-rentals`}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4" />
                Southwest Florida
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4" />
                info@swflvacationrentals.com
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Phone className="w-4 h-4" />
                (239) 555-0123
              </li>
            </ul>
            <div className="mt-6">
              <Link 
                to="/host" 
                className="btn-primary inline-block text-sm"
              >
                List Your Property
              </Link>
            </div>
          </div>
        </div>

        {/* Legal Links */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <div>
              <h4 className="font-medium text-white mb-3">Company</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/platform-disclaimer" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Platform Disclaimer
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-white mb-3">Guests</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/guest-responsibilities" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Guest Responsibilities
                  </Link>
                </li>
                <li>
                  <Link to="/cancellation" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Cancellation Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-white mb-3">Hosts</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/host-obligations" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Host Obligations
                  </Link>
                </li>
                <li>
                  <Link to="/payments" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Payments & Payouts
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-white mb-3">Support</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/help" className="text-slate-400 hover:text-white text-sm transition-colors">
                    Help Center
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} Southwest Florida Vacation Rentals. All rights reserved.
          </p>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">
              Privacy
            </Link>
            <Link to="/cancellation" className="text-slate-400 hover:text-white text-sm transition-colors">
              Cancellation
            </Link>
            <Link to="/payments" className="text-slate-400 hover:text-white text-sm transition-colors">
              Payments
            </Link>
          </div>
          <div className="text-slate-500 text-xs mt-4">
            A product of Invigor Digital.
          </div>
        </div>
      </div>
    </footer>
  );
}
